module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Terminal-d4d8543c2aa0dba3793887e7bb3464de.svg";